<app-application-logs [applicationId]="route.snapshot.params.applicationId"></app-application-logs>
